import { render, staticRenderFns } from "./OrderSkeleton.vue?vue&type=template&id=5978e260&scoped=true&"
var script = {}
import style0 from "./OrderSkeleton.vue?vue&type=style&index=0&id=5978e260&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978e260",
  null
  
)

export default component.exports